<script>
	export let showModal; // boolean

	let dialog; // HTMLDialogElement

	$: if (dialog && showModal) {
		dialog.showModal();
		document.querySelector("body")?.classList.add('modal-open');
	}

	function closeModal() {
		dialog.close();
		document.querySelector("body")?.classList.remove('modal-open');
	}
  
	function handleWindowKeyDown(event) {
		if ((event.key === 'Escape') && (showModal == true)) {
			closeModal();
		}
	}
</script>

<svelte:window on:keydown={handleWindowKeyDown} />
<dialog
	id="modal_"
	bind:this={dialog}
	on:close={() => (showModal = false)}
	on:click|self={() => closeModal()}
	aria-hidden="{ (showModal == true) ? false: true}"
    aria-describedby="aria-description"
>
  <p id="aria-description" class="sr-only">Dialog window open over the content of the page.</p>
	<div class="modal-container" autofocus >
		<div class="close">
			<button
				class="close-button" 
				aria-label="Select to close the dialog window." 
				on:click={() => closeModal()}>
				<svg viewBox="0 0 14 14"> 
					<g> <path fill-rule="nonzero" d="M6.336 7L0 .664.664 0 7 6.336 13.336 0 14 .664 7.664 7 14 13.336l-.664.664L7 7.664.664 14 0 13.336 6.336 7z"></path> </g>
				</svg>
			</button>
		</div>
        <slot name="header" />
		<slot name="product-details" />
		<slot name="body" />
		<slot name="pesticides" />
      
    </div>

</dialog>